// extracted by mini-css-extract-plugin
export default {"content":"ConfiguratorLayout_content__W8u-m","main":"ConfiguratorLayout_main__mIZ18"};